module.exports = __webpack_public_path__ + "static/img/ent-detail-97.914cc8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-97.jpg
// module id = 3RER
// module chunks = 51